mutation ReconcileRefund($refundId: ID!, $refunded: Boolean!) {
  reconcileRefund(refundId: $refundId, refunded: $refunded) {
    id
    status
    reconciledAt
  }
}
